export const BADGE = {
  slate: 'text-black bg-slate-50 border-slate-500',
  teal: 'text-black bg-teal-50 border-teal-500',
  orange: 'text-orange-800 bg-orange-50 border-none',
  warm: 't-badge border-none',
} as const;

type ObjectValues<T> = T[keyof T];
export type BadgeType = ObjectValues<typeof BADGE>;
